import { render, staticRenderFns } from "./person_tabs.vue?vue&type=template&id=b17a1504&"
import script from "./person_tabs.vue?vue&type=script&lang=js&"
export * from "./person_tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b17a1504')) {
      api.createRecord('b17a1504', component.options)
    } else {
      api.reload('b17a1504', component.options)
    }
    module.hot.accept("./person_tabs.vue?vue&type=template&id=b17a1504&", function () {
      api.rerender('b17a1504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/people/person_tabs.vue"
export default component.exports